import React, { useCallback, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import DoneIcon from '@material-ui/icons/Done';
import NetworkCheckIcon from '@material-ui/icons/NetworkCheck';

import styles from './Controls.css';


const StyledMenuItem = withStyles(() => {
  return { root: { '&:not(.active)': { paddingLeft: '2rem' } } };
})(MenuItem);

function StreamQualityOptions(props) {
  const {
    options,
    onStreamQualityChange,
    activeOption,
    isDesktop,
    setHideIconsTimeout,
    clearHideIconsTimeout,
    videoAndChatWrapper,
  } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const containerRef = useRef(null);

  const onClick = useCallback((event) => {
    event.stopPropagation();
    clearHideIconsTimeout?.();
    setAnchorEl(event.currentTarget);
  }, [clearHideIconsTimeout]);

  const onCloseMenu = useCallback(() => {
    setAnchorEl(null);
    setHideIconsTimeout?.();
  }, [setHideIconsTimeout]);

  const handleClose = (key) => () => {
    setAnchorEl(null);
    onStreamQualityChange(key);
  };

  const containerClasses = classnames([styles.rightControlsItem, styles.qualityContainer]);
  const menuClass = !isDesktop ? { paper: styles.menuWrapper } : null;
  const menuId = 'quality-controls-menu';

  return (
    <div ref={containerRef} className={containerClasses}>
      {isDesktop ? (
        <span
          aria-controls={menuId}
          aria-haspopup="true"
          onClick={onClick}
        >
          {activeOption.label}
        </span>
      ) : (
        <NetworkCheckIcon
          aria-controls={menuId}
          aria-haspopup="true"
          className={styles.qualityControl}
          onClick={onClick}
        />
      )}
      <Menu
        anchorEl={anchorEl}
        classes={menuClass}
        container={videoAndChatWrapper}
        disableEnforceFocus={true}
        id={menuId}
        keepMounted={true}
        open={Boolean(anchorEl)}
        onClose={onCloseMenu}
        onExit={onCloseMenu}
      >
        {options.map((option) => (
          <StyledMenuItem
            key={option.key}
            className={classnames({ active: option.active })}
            onClick={handleClose(option.key)}
          >
            {option.active && (
              <DoneIcon
                className={styles.doneIcon}
                fontSize="small"
              />
            )}
            {option.label}
          </StyledMenuItem>
        ))}
      </Menu>
    </div>
  );
}

StreamQualityOptions.propTypes = {
  activeOption: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  onStreamQualityChange: PropTypes.func.isRequired,
  clearHideIconsTimeout: PropTypes.func,
  isDesktop: PropTypes.bool,
  setHideIconsTimeout: PropTypes.func,
  videoAndChatWrapper: PropTypes.object,
};

StreamQualityOptions.defaultProps = {
  clearHideIconsTimeout: () => undefined,
  isDesktop: false,
  setHideIconsTimeout: () => undefined,
  videoAndChatWrapper: undefined,
};

export default StreamQualityOptions;
